import {Card, Timeline} from "antd";
import React from "react";
import dayjs from "dayjs";
import {isEmpty} from "../../../../GlobalServices";

export interface Props {
    komentarze: any;
}

const Komentarze = ({komentarze}: Props) => {

    return (<div>
            {komentarze &&
                <Timeline
                    mode={'left'}
                    reverse={false}
                    items={komentarze.map((kom: any) => ({label: isEmpty(kom.dataWpisu)? '' : dayjs(kom.dataWpisu).format('YYYY-MM-DD HH:mm'), children: kom.tresc}))}
                    style={{marginTop: '30px'}}
                />
            }
    </div>
    )
}

export default Komentarze;
